import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DropLi, useFormatPrice } from "../../../../hooks";
import { action, API, controller } from "../../../../api/api";

const AccountsWidget = ({ cstmr }) => {
  const formatPrice = useFormatPrice();
  const { AccBalTypes } = DropLi();
  const [balType, setBalType] = useState("");
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState({});

  useEffect(() => {
    if (cstmr) {
      setLoading(true);
      API(controller.CustomerTxn + action.GetAccountsByCustomer).getById(
        cstmr.id,
        (res) => {
          setLoading(false);
          res && res.status === 200
            ? setAccounts({ ...res.result })
            : console.error("Error: ", res);
        }
      );

      // Get name of the account balance type.
      if (cstmr.accBalType) {
        var balType = AccBalTypes.find((j) => j.id === cstmr.accBalType);
        balType && setBalType(balType.label);
      } else setBalType("");
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cstmr]);

  return !loading ? (
    <Grid container spacing={3} className="text-[15px]">
      <Grid item xs={12} md={6}>
        <div className="grid gap-[5px] mt-[10px] text-gray-500">
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">Balance:</span>
            <span>{formatPrice(accounts.balance)}</span>
          </div>
          <Divider />
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">
              Balance excluding layby/layaway:
            </span>
            <span>{formatPrice(accounts.onAccount)}</span>
          </div>
          <Divider />
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">Layby/layaway:</span>
            <span>{formatPrice(accounts.layby)}</span>
          </div>
          <Divider />
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">Allow on-account balance:</span>
            <span>{balType}</span>
          </div>
          <Divider />
        </div>
      </Grid>
      <Grid item xs={12} md={6}>
        <div className="grid gap-[5px] mt-[10px] text-gray-500">
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">Total spent:</span>
            <span>{formatPrice(accounts.totalSpent)}</span>
          </div>
          <Divider />
          <div className="text-gray-color flex justify-between">
            <span className="font-medium">Last 12 months:</span>
            <span>{formatPrice(accounts.last12Months)}</span>
          </div>
        </div>
      </Grid>
    </Grid>
  ) : (
    <span className="p-[15px] text-[18px] font-medium text-gray-500">
      Loading...
    </span>
  );
};

export default AccountsWidget;
